import { AddressComponents } from "./address-comments.model";
import { AcceptanceStatus } from "./events.model";
import { TimeRange } from "./time-range.model";

export interface LeadTimeRange {
    id: number;
    leadId: number;
    startTime: Date;
    endTime: Date;
}

export interface Lead {
    docType: 'Lead';
    id: number;
    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;
    assigneeId: number | null;
    assigneeFirstName: string | null;
    assigneeLastName: string | null;
    address: AddressComponents;
    businessName: string | null;
    createdAt: Date;
    email: string | null;
    type: 'personal' | 'business';
    firstName: string;
    lastName: string;
    clientId: number;
    clientCreatedAt: Date;
    salesTaxPercentage: number;
    jobType: string;
    phoneNumber: string;
    extNumber: string | null;
    unit: string | null;
    workflowId: number;
    ranges: TimeRange[];
    denied: boolean;
}

export interface LeadTileData {
    docType: 'Lead';
    id: number;
    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;
    assigneeId: number | null;
    assigneeFirstName: string | null;
    assigneeLastName: string | null;
    businessName: string | null;
    createdAt: Date;
    firstName: string;
    lastName: string;
    clientId: number;
    clientCreatedAt: Date;
    salesTaxPercentage: number;
    jobType: string;
    phoneNumber: string;
    workflowId: number;
    rangeId: number;
    startTime: Date;
    endTime: Date;
}

export function leadTileData(from: Lead, rangeId: number): LeadTileData {
    const range = from.ranges.find(r => (r as any).rangeId === rangeId)!;
    return {
        docType: 'Lead',
        id: from.id,
        createdAt: from.createdAt,
        assigneeId: from.assigneeId,
        ownerId: from.ownerId,
        ownerFirstName: from.ownerFirstName,
        ownerLastName: from.ownerLastName,
        assigneeFirstName: from.assigneeFirstName,
        assigneeLastName: from.assigneeLastName,
        businessName: from.businessName,
        firstName: from.firstName,
        lastName: from.lastName,
        jobType: from.jobType,
        phoneNumber: from.phoneNumber,
        startTime: range.startTime,
        endTime: range.endTime,
        rangeId,
        workflowId: from.workflowId,
        clientId: from.clientId,
        clientCreatedAt: from.clientCreatedAt,
        salesTaxPercentage: from.salesTaxPercentage,
    };
}

export function leadAcceptanceStatus(lead: Lead): AcceptanceStatus {
    if(lead.assigneeId === null)
        return 'accepted';
    if(lead.denied)
        return 'denied';
    return 'pending';
}
